import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
export default {
  data: function data() {
    return {
      arr: []
    };
  },
  computed: {},
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var URL, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            URL = "/pjyy-deepexi-product-center/api/v1/product/PcProductConfigure/selectConfigureList?key=" + 'APP_PRODUCT_LABE';
            _context.next = 3;
            return _this.$getHttpClient().get(URL);
          case 3:
            result = _context.sent;
            if (result.data.code == 200) {
              _this.arr = result.data.data;
              _this.arr.map(function (item) {
                console.log(item);
                if (item.tabnav == 1) {
                  item.children.map(function (item1) {
                    item1.datalist = [];
                    item1.pagenum = 0;
                    item = item1;
                  });
                }
                if (item.tabnav == 3) {
                  item.pagenum = 0;
                  item.datalist = [];
                }
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {}
};